// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__FeII0","tabSpinner":"Spinner_tabSpinner__FqC2P"};